import { useState, useRef } from "react";
import { motion, AnimatePresence, ease as mmEase, useInView } from "@/lib/motion";
import { TESTIMONIALS } from "../data";

const ez = mmEase.expo;

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const ref    = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px 0px" });
  const t      = TESTIMONIALS[active];

  return (
    <section ref={ref} className="py-32 px-6" style={{ background: "var(--color-section-cream)" }}>
      <div className="max-w-[1200px] mx-auto">

        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.55, ease: ez }}
          className="mb-12"
        >
          <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-emerald mb-3">
            Customer voices
          </p>
          <h2
            className="font-display font-black text-navy text-balance"
            style={{ fontSize: "clamp(1.6rem, 3.2vw, 2.5rem)", letterSpacing: "-0.032em" }}
          >
            People before calculators.
          </h2>
        </motion.div>

        <AnimatePresence mode="wait">
          <motion.div
            key={active}
            initial={{ opacity: 0, y: 14, filter: "blur(4px)" }}
            animate={{ opacity: 1, y: 0,  filter: "blur(0px)" }}
            exit={{    opacity: 0, y: -8, filter: "blur(2px)" }}
            transition={{ duration: 0.38, ease: ez }}
            className="card-float p-8 sm:p-10 mb-8 max-w-3xl"
          >
            <blockquote
              className="font-display font-bold text-navy leading-snug mb-7"
              style={{ fontSize: "clamp(1.05rem, 2.2vw, 1.45rem)", letterSpacing: "-0.018em" }}
            >
              "{t.quote}"
            </blockquote>
            <div className="flex items-center gap-4">
              <img
                src={t.photo}
                alt={t.name}
                className="w-12 h-12 rounded-full object-cover shrink-0"
              />
              <div>
                <p className="font-bold text-navy text-[14px]">{t.name}</p>
                <p className="text-[12px]" style={{ color: "rgba(11,29,58,0.45)" }}>
                  {t.role} · {t.city}
                </p>
              </div>
              <div className="ml-auto hidden sm:block">
                <span
                  className="text-[10px] font-bold px-3 py-1.5 rounded-full"
                  style={{ background: `${t.color}12`, color: t.color }}
                >
                  {t.corridor}
                </span>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>

        <div className="flex items-center gap-4">
          {TESTIMONIALS.map((person, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              aria-label={`View ${person.name}'s testimonial`}
              aria-pressed={i === active}
              className="transition-all"
              style={{
                borderRadius: "50%", overflow: "hidden",
                width: "40px", height: "40px", flexShrink: 0,
                border: "none", padding: 0, cursor: "pointer",
                opacity:       i === active ? 1 : 0.42,
                transform:     i === active ? "scale(1.12)" : "scale(1)",
                outline:       i === active ? `2px solid ${person.color}` : "none",
                outlineOffset: "3px",
              }}
            >
              <img
                src={person.photo}
                alt={person.name}
                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
            </button>
          ))}
          <span className="text-[11px] ml-2" style={{ color: "rgba(11,29,58,0.28)" }}>
            {active + 1} of {TESTIMONIALS.length}
          </span>
        </div>

      </div>
    </section>
  );
}
